export const PRODUCT_ID = {
  FFP_CANINE_POSITIVE_SINGLE_UNIT: 8179,
  FFP_CANINE_POSITIVE_DOUBLE_UNIT: 504,
  FFP_CANINE_NEGATIVE_DOUBLE_UNIT: 503,
  FFP_CANINE_NEGATIVE_SINGLE_UNIT: 502,
  FFP_CRYOPRECIPITATE_CRYO_POOR: 15874,
  FFP_CRYOPRECIPITATE_CRYO_RICH: 15186,
  PRBC_CANINE_POSITIVE_SINGLE_UNIT: 463,
  PRBC_CANINE_NEGATIVE_SINGLE_UNIT: 411,
  WHOLE_BLOOD_CANINE_UNIT: 12779,
  WHOLE_BLOOD_NEGATIVE_DOUBLE: 9483,
  WHOLE_BLOOD_POSITIVE_DOUBLE: 14349,
};
